<template>
    <div>
         <b-card header-tag="header">
            <template #header>
                <div class="col-12">
                    <div class="d-flex justify-content-between">
                        <h4 class="mb-0 fw-bold">จำนวนพัสดุที่ตกค้าง</h4>
                        <h4 class="mb-0 fw-bold">จำนวนพัสดุ : {{countSuccess}}</h4>
                    </div>
                </div>
            </template>
            <div class="col-12">
                <form @submit.prevent="onInput()">
                    <b-form-input 
                        :ref="'sop'" 
                        :state="error.input"
                        @blur="onFocusOut()"
                        :disabled="isLoad"
                        :formatter="formatter"
                        v-model="trackingCode"
                    >
                    </b-form-input>
                </form>
                <div class="circle-loading loading-input" v-if="isLoad"></div>
                <b-form-invalid-feedback :state="error.input">
                    {{error.msg}}
                </b-form-invalid-feedback>
                <b-form-valid-feedback :state="error.input">
                    {{error.msg}}
                </b-form-valid-feedback>
            </div>
         </b-card>
    </div>
</template>
<script>
export default {
    data(){
        return {
            countSuccess: 0,
            isLoad: false,
            trackingCode: "",
            deliveryId: null,
            error:{
                input: null,
                msg: ""
            }
        }
    },
    mounted(){
        this.autoFocusToInput()
    },
    methods:{
        formatter(value){
            return value.toUpperCase()
        },
        autoFocusToInput(){
            this.$refs.sop.$el.focus()
        },
        async onInput(){
            if( this.trackingCode.length < 11 ){
                this.clearValidateInput()
                return false
            }
            const check = this.validateInput(this.trackingCode)
            if( check.status === false ){
                this.error.input = check.status
                this.error.msg = check.msg
                this.clearInputTrackingCode()
                return false
            }else{
                this.clearValidateInput()
            }

            const resAPI = await this.createdeliverySOPAPI(this.deliveryId, this.trackingCode)
            if( !resAPI.status ){
                this.error.input = resAPI.status
                this.error.msg = resAPI.error.msg
                this.clearInputTrackingCode()
                return false
            }else{
                this.countSuccess++
                this.error.input = true
                this.error.msg = `อัพเดทหมายเลข ${this.trackingCode} สำเร็จ`
                this.setDeliveryId(resAPI.data.delivery_id)
                this.clearInputTrackingCode()
                this.$emit('onUpdate', resAPI.data.order_detail_ids)
            }

        },
        clearValidateInput(){
            this.error.input = null
            this.error.msg = ""
        },
        clearInputTrackingCode(){
            this.trackingCode = ""
            this.autoFocusToInput()
        },
        validateInput( string ){
            let res = {
                status: false,
                msg: ""
            }
            let pattern = /^[A-Z0-9]+$/;
            let checkCharacter = pattern.test(string)
            if( !checkCharacter ){
                res.msg = 'กรุณาเปลี่ยนภาษาคีย์บอร์ด'
                return res
            }
            if( string.length < 11 ){
                res.msg = `รหัส Tracking Code ไม่ถูกต้อง: ${string}`
                return res
            }
            res.status = true
            return res
        },
        setDeliveryId(deliveryId){
            this.deliveryId = deliveryId
        },
        onFocusOut(){
            if( this.trackingCode.length < 1 ){
                this.clearValidateInput()
            }
        },
        async createdeliverySOPAPI( deliveryId, trackingCode){
            const uri = '/shop/create/delivery/sop'
            const header = {
                headers: {
                Token: localStorage.getItem("access_token")
                }
            }
            const body = {
                delivery_id: deliveryId,
                tracking_code: trackingCode
            }
            this.isLoading()
            const res = await this.$http.post( this.$API_URL + uri, body, header)
            this.isLoaded()
            try{
                return res.data

            } catch ( e ){
                console.info(e)
                return {
                    status: false,
                    msg: "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง"
                }
            }
        },
        isLoading(){
            this.isLoad = true
        },
        isLoaded(){
            this.isLoad = false
        }
    }
}
</script>
<style lang="scss" scoped>
    .loading-input{
        position: absolute;
        top: 16px;
        right: 28px;
    }
</style>